import {SettingsMetaResponse} from './SettingsMetaResponse';

export class SettingsMetaListResponse
{
    public readonly settingsList:SettingsMetaResponse[];

    constructor(json:any)
    {
        this.settingsList = [];
        for( let i = 0, length = (json['settingsList'] || []).length; i < length; i++ )
        {
            this.settingsList.push(new SettingsMetaResponse(json['settingsList'][i]));
        }
    }
}
